var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-flex align-center"},[_c('div',{staticStyle:{"line-height":"1"},on:{"click":function($event){$event.stopPropagation();}}},[_c('AppToolTip',{attrs:{"label":_vm.description},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('AppIcon',_vm._g(_vm._b({staticClass:"ml-1",attrs:{"icon":"help","fill":_vm.$vuetify.theme.themes.light.greyLight}},'AppIcon',attrs,false),on))]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }